import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/user/line_back_ico_l.png'
import _imports_1 from '@/assets/user/c_arrow_w_l.png'
import _imports_2 from '@/assets/user/c_arrow_w_r.png'


const _hoisted_1 = { class: "layer" }
const _hoisted_2 = { class: "wrap" }
const _hoisted_3 = { class: "content" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, "BACK", -1)
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "page_title" }, "심박수 상세 데이터", -1)
const _hoisted_8 = { class: "graph_box" }
const _hoisted_9 = { class: "graph_date_box" }
const _hoisted_10 = { type: "button" }
const _hoisted_11 = { type: "button" }
const _hoisted_12 = { class: "data_detail_wrap" }
const _hoisted_13 = {
  class: "data_detail",
  id: "heart_rate"
}
const _hoisted_14 = { class: "min" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", null, "최저 심박수", -1)
const _hoisted_16 = { class: "ave" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("p", null, "평균 심박수", -1)
const _hoisted_18 = { class: "max" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("p", null, "최고 심박수", -1)
const _hoisted_20 = {
  class: "data_detail",
  id: "heart_status_list"
}
const _hoisted_21 = { class: "" }
const _hoisted_22 = { class: "hs_graph_div" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("p", { class: "hs_tit" }, "고강도 심박(167bpm 이상)", -1)
const _hoisted_24 = { class: "hs_graph" }
const _hoisted_25 = { class: "hs_time_div" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("b", null, "초", -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("b", null, "%", -1)
const _hoisted_28 = { class: "hs_graph_div" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("p", { class: "hs_tit" }, "중강도 심박(110 ~ 166bpm 이상)", -1)
const _hoisted_30 = { class: "hs_graph" }
const _hoisted_31 = { class: "hs_time_div" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("b", null, "초", -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("b", null, "%", -1)
const _hoisted_34 = { class: "hs_graph_div" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("p", { class: "hs_tit" }, "저강도 심박(109bpm 이하)", -1)
const _hoisted_36 = { class: "hs_graph" }
const _hoisted_37 = { class: "hs_time_div" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("b", null, "초", -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("b", null, "%", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderLayout = _resolveComponent("HeaderLayout")!
  const _component_Chart = _resolveComponent("Chart")!
  const _component_GnbLayout = _resolveComponent("GnbLayout")!
  const _component_ModalComponent = _resolveComponent("ModalComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_HeaderLayout),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            type: "button",
            class: "in_back_btn",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.backList && $setup.backList(...args)))
          }, _hoisted_6),
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_Chart, {
              titlePadding: $setup.state.titlePadding,
              data: $setup.state.chartList,
              legendPosition: $setup.state.legendPosition,
              width: $setup.state.chartWidth,
              height: $setup.state.chartHeight,
              title: $setup.state.title,
              subTitle: $setup.state.subTitle
            }, null, 8, ["titlePadding", "data", "legendPosition", "width", "height", "title", "subTitle"])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("button", _hoisted_10, [
              _createElementVNode("img", {
                src: _imports_1,
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.prevDate && $setup.prevDate(...args)))
              })
            ]),
            _createElementVNode("span", null, _toDisplayString($setup.dateFormat($setup.health.date)), 1),
            _createElementVNode("button", _hoisted_11, [
              _createElementVNode("img", {
                src: _imports_2,
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.nextDate && $setup.nextDate(...args)))
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("span", null, [
                  _createElementVNode("b", null, _toDisplayString($setup.health.min), 1),
                  _createTextVNode("bpm")
                ]),
                _hoisted_15
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("span", null, [
                  _createElementVNode("b", null, _toDisplayString($setup.health.avg), 1),
                  _createTextVNode("bpm")
                ]),
                _hoisted_17
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("span", null, [
                  _createElementVNode("b", null, _toDisplayString($setup.health.max), 1),
                  _createTextVNode("bpm")
                ]),
                _hoisted_19
              ])
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("ul", _hoisted_21, [
                _createElementVNode("li", null, [
                  _createElementVNode("div", _hoisted_22, [
                    _hoisted_23,
                    _createElementVNode("p", _hoisted_24, [
                      _createElementVNode("span", {
                        style: _normalizeStyle(`width: ${(($setup.health.cntHigh / $setup.health.cntTotal) * 100).toFixed(1)}%`)
                      }, null, 4)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _createTextVNode(_toDisplayString($setup.timeCalculation($setup.health.cntHigh)), 1),
                    _hoisted_26,
                    _createTextVNode(" (" + _toDisplayString((($setup.health.cntHigh / $setup.health.cntTotal) * 100).toFixed(1)), 1),
                    _hoisted_27,
                    _createTextVNode(") ")
                  ])
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("div", _hoisted_28, [
                    _hoisted_29,
                    _createElementVNode("p", _hoisted_30, [
                      _createElementVNode("span", {
                        style: _normalizeStyle(`width: ${(($setup.health.cntMiddle / $setup.health.cntTotal) * 100).toFixed(
                                            1,
                                        )}%`)
                      }, null, 4)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_31, [
                    _createTextVNode(_toDisplayString($setup.timeCalculation($setup.health.cntMiddle)), 1),
                    _hoisted_32,
                    _createTextVNode(" (" + _toDisplayString((($setup.health.cntMiddle / $setup.health.cntTotal) * 100).toFixed(1)), 1),
                    _hoisted_33,
                    _createTextVNode(") ")
                  ])
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("div", _hoisted_34, [
                    _hoisted_35,
                    _createElementVNode("p", _hoisted_36, [
                      _createElementVNode("span", {
                        style: _normalizeStyle(`width: ${(($setup.health.cntLow / $setup.health.cntTotal) * 100).toFixed(1)}%`)
                      }, null, 4)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_37, [
                    _createTextVNode(_toDisplayString($setup.timeCalculation($setup.health.cntLow)), 1),
                    _hoisted_38,
                    _createTextVNode(" (" + _toDisplayString((($setup.health.cntLow / $setup.health.cntTotal) * 100).toFixed(1)), 1),
                    _hoisted_39,
                    _createTextVNode(") ")
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_GnbLayout),
    _createVNode(_component_ModalComponent, {
      show: $setup.state.isModalOpen,
      yes: $setup.modal.confirm,
      no: $setup.modal.cancel,
      content: $setup.modal.content,
      onClose: $setup.modalClose
    }, null, 8, ["show", "yes", "no", "content", "onClose"])
  ], 64))
}